export default function sortBooks(books, sortType) {
    let sortedBooks = [...books];

    sortedBooks.sort((a, b) => {
        switch (sortType) {
            case 'AZ':
                return a.title.localeCompare(b.title);
            case 'ZA':
                return b.title.localeCompare(a.title);
            case 'LowToHighRate':
                return a.ratings_sortable - b.ratings_sortable;
            case 'HighToLowRate':
                return b.ratings_sortable - a.ratings_sortable;
            default:
                return 0;
        }
    });

    return sortedBooks;
}